/* MEG 21 Face v4 — carousel dots/arrows + Add-to-cart for the lower sections. Tab, Oct 16 2026. */
(function(){
  function initCar(root){
    if(root.__mf4) return; root.__mf4=1;
    var track=root.querySelector('.mf4-track'); if(!track) return;
    var ctrl=root.querySelector('.mf4-ctrl'), dots=root.querySelector('.mf4-dots');
    var prev=root.querySelector('.mf4-arw.prev'), next=root.querySelector('.mf4-arw.next');
    var slides=[].slice.call(track.children);
    function scrollable(){return track.scrollWidth>track.clientWidth+4 && getComputedStyle(track).overflowX!=='visible';}
    function step(){ if(slides.length<2) return track.clientWidth; return slides[1].offsetLeft-slides[0].offsetLeft; }
    function pages(){ var s=step(); if(!s) return 1; return Math.max(1,Math.round((track.scrollWidth-track.clientWidth)/s)+1); }
    function idx(){ var s=step(); return s?Math.round(track.scrollLeft/s):0; }
    function build(){
      if(!ctrl) return;
      if(!scrollable()){ctrl.hidden=true;return;}
      ctrl.hidden=false; var n=Math.min(pages(),slides.length);
      if(dots && dots.children.length!==n){ dots.innerHTML='';
        for(var i=0;i<n;i++){ var b=document.createElement('button'); b.type='button'; b.setAttribute('role','tab'); b.setAttribute('aria-label','Go to slide '+(i+1));
          (function(k){b.addEventListener('click',function(){track.scrollTo({left:k*step(),behavior:'smooth'});});})(i); dots.appendChild(b);} }
      sync();
    }
    function sync(){ var i=idx(), n=dots?dots.children.length:0;
      if(track.scrollLeft+track.clientWidth>=track.scrollWidth-4) i=n-1;
      for(var k=0;k<n;k++) dots.children[k].setAttribute('aria-selected',k===i?'true':'false');
      if(prev) prev.disabled=i<=0; if(next) next.disabled=i>=n-1; }
    var t; track.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(sync,60);},{passive:true});
    if(prev) prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    if(next) next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(build,120);});
    build();
  }
  function initAdd(form){
    if(form.__mf4) return; form.__mf4=1;
    form.addEventListener('submit',function(e){
      if(!window.fetch) return; e.preventDefault();
      var btn=form.querySelector('button[type=submit]'); var label=btn?btn.textContent:'';
      if(btn){btn.disabled=true;btn.textContent='Adding…';}
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){if(!r.ok) throw r; return r.json();})
        .then(function(item){
          if(btn){btn.textContent='Added ✓';}
          return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
            document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'mf4-pairs',data:{source:'product-form-component',itemCount:1,productId:item.product_id}}}));
            document.querySelectorAll('[data-cart-count],.cart-count,.cart-bubble__text').forEach(function(el){ if(/^\d*$/.test(el.textContent.trim())) el.textContent=cart.item_count; });
          });
        })
        .catch(function(){ form.submit(); })
        .finally(function(){ setTimeout(function(){ if(btn){btn.disabled=false;btn.textContent=label;} },2200); });
    });
  }
  function init(){ document.querySelectorAll('.mf4 [data-mf4-car]').forEach(initCar); document.querySelectorAll('.mf4 form[data-mf4-add]').forEach(initAdd); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
